export const Monogram = ({ size = 120, className = "", tone = "gold" }) => {
    const stroke = tone === "gold" ? "#C9A227" : "#FBF8F2";
    const leaves = [];
    for (let i = 0; i < 5; i++) {
        const a = 150 + i * 14;
        const b = 30 - i * 14;
        leaves.push({ angle: a, key: `l${i}` });
        leaves.push({ angle: b, key: `r${i}` });
    }
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 200 200"
            className={className}
            data-testid="el-monogram"
            role="img"
            aria-label="Events by Leemerh monogram"
        >
            <circle cx="100" cy="100" r="96" fill="none" stroke={stroke} strokeWidth="1.6" />
            <circle cx="100" cy="100" r="88" fill="none" stroke={stroke} strokeWidth="0.8" opacity="0.6" />
            {leaves.map((leaf) => (
                <g key={leaf.key} transform={`rotate(${leaf.angle} 100 100)`}>
                    <ellipse
                        cx="100"
                        cy="8"
                        rx="2.4"
                        ry="6"
                        fill="none"
                        stroke={stroke}
                        strokeWidth="0.9"
                        opacity="0.85"
                        transform="rotate(24 100 8)"
                    />
                </g>
            ))}
            <text
                x="100"
                y="116"
                textAnchor="middle"
                fill={stroke}
                style={{ fontFamily: "'Great Vibes', cursive", fontSize: "76px" }}
            >
                EL
            </text>
            <path
                d="M100 158 c-5-7-14-3.5-14 3.5 c0 5.5 7 9 14 14.5 c7-5.5 14-9 14-14.5 c0-7-9-10.5-14-3.5z"
                fill={stroke}
                opacity="0.9"
            />
            <line x1="62" y1="152" x2="88" y2="152" stroke={stroke} strokeWidth="0.7" opacity="0.7" />
            <line x1="112" y1="152" x2="138" y2="152" stroke={stroke} strokeWidth="0.7" opacity="0.7" />
        </svg>
    );
};

export const GoldHeart = ({ size = 16, className = "" }) => (
    <svg width={size} height={size} viewBox="0 0 24 24" className={className} aria-hidden="true">
        <path
            d="M12 20.5 c-7-4.5-10-8.2-10-12 A5.5 5.5 0 0 1 12 5 a5.5 5.5 0 0 1 10 3.5 c0 3.8-3 7.5-10 12z"
            fill="none"
            stroke="#C9A227"
            strokeWidth="1.4"
        />
    </svg>
);
